module.exports = __webpack_public_path__ + "img/OndasTarjeta02.7dd6f13b.svg";